import { render } from "./StepAboutYou.vue?vue&type=template&id=2b55ed7c&ts=true"
import script from "./StepAboutYou.vue?vue&type=script&lang=ts"
export * from "./StepAboutYou.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__